import React from 'react';
import {Dialog, DialogContent} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import JsonScreen from "../index";
import SchemaDesigner from "../../SchemaDesigner";
import MenuDesigner from "../../MenuDesignerNew";
import {useLocation} from "react-router-dom";
import {useHistory} from "react-router";
import usePopup from "./usePopup";
import {useActions} from "../../../app/doActions";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import Drawer from "@material-ui/core/Drawer";

const useStyles = makeStyles(() => ({
    dialogRootPaper: {},
    dialogRoot: {
        padding: 0
    },
    contentRoot: {
        padding: 0,
        '&:first-child': {
            padding: 0
        }
    }
}));

const PopupScreenWithHook = () => {
    const {popupState, closePopup} = usePopup();
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const {doActions, onChangeFields, cameraRef} = useActions();
    const {popups, availablePopups} = popupState;

    function renderDialogs() {
        return [...availablePopups].map((popupName) => {
            const {open, inParam, name, returnValue, presentation, width, height} = popups[popupName] || {}
            const match = {params: {name}}
            if (presentation === 'drawer') {
                return <Drawer
                    open={open}
                    anchor={"right"}
                    onClose={() => closePopup(true, name)}
                    PaperProps={{
                        style: {
                            width: width
                        }
                    }}
                >
                    {open && (
                        <DndProvider backend={HTML5Backend}>
                            <CustomRouting
                                match={match}
                                closePopup={() => closePopup(true, name)}
                                isPopUp={true}
                                screenName={name}
                                popupState={{
                                    screenName: name,
                                    inParam,
                                }}
                                location={{
                                    ...location,
                                    state: {...location.state}
                                }}
                                history={history}
                                doActions={doActions}
                                onChangeFields={onChangeFields}
                                returnValue={returnValue}
                                cameraRef={cameraRef}
                            />
                        </DndProvider>
                    )}
                </Drawer>
            }
            return (
                <Dialog
                    anchor={"right"}
                    classes={{paper: classes.dialogRootPaper, root: classes.dialogRoot}}
                    open={open}
                    PaperProps={{
                        style: {
                            width,
                            height
                        }
                    }}
                    onClose={() => closePopup(true, name)} maxWidth={"xl"}>
                    <DialogContent classes={{root: classes.contentRoot}}>
                        {open && (
                            <DndProvider backend={HTML5Backend}>
                                <CustomRouting
                                    match={match}
                                    closePopup={() => closePopup(true, name)}
                                    isPopUp={true}
                                    screenName={name}
                                    popupState={{
                                        screenName: name,
                                        inParam,
                                    }}
                                    location={{
                                        ...location,
                                        state: {...location.state}
                                    }}
                                    history={history}
                                    doActions={doActions}
                                    onChangeFields={onChangeFields}
                                    returnValue={returnValue}
                                    cameraRef={cameraRef}
                                />
                            </DndProvider>
                        )}
                    </DialogContent>
                </Dialog>
            )
        })
    }

    return renderDialogs()
};
export default PopupScreenWithHook;

const CustomRouting = (props) => {
    const {
        screenName, match, closePopup,
        location, history, returnValue, popupState, doActions, onChangeFields,cameraRef
    } = props;

    switch (screenName) {
        case 'schemaDesigner':
            return <SchemaDesigner match={match}
                                   closePopup={closePopup}
                                   isPopup={true}
                                   inParam={popupState.inParam}
                                   returnValue={returnValue}
                                   doActions={doActions}
            />;
        case 'menuDesigner':
            return <MenuDesigner match={match}
                                 returnValue={returnValue}
                                 closePopup={closePopup}
                                 isPopup={true}
                                 inParam={popupState.inParam['menuDesigner']}
            />;
        default:
            return (<JsonScreen match={match}
                                popupState={popupState}
                                closePopUp={closePopup}
                                isPopUp={true}
                                location={location}
                                history={history}
                                doActions={doActions}
                                onChangeFields={onChangeFields}
                                returnValue={returnValue}
                                cameraRef={cameraRef}
            />)
    }
};
